import React, { useEffect } from 'react';
import { useStore } from 'effector-react';
import { toFlag } from 'pano-utils';
import { HSIconType } from '@types';
import { Collapse } from '@components/Collapse';
import Textarea from '@components/Textarea';
import useTextareaHandelrs from '@hooks/useTextareaHandelrs';
import Button from '@components/Button';
import {
  $editingHotspot,
  $editingHotspotApi,
} from '@stores/editingHotspotStores';
import FeatureToggle from '@components/FeatureToggle';
import { $playerWidgetsApi } from '@stores/playerWidgets';

interface TitleSettingProps {
  placeholder?: string;
}

function TitleSetting({ placeholder = '请输入热点标题' }: TitleSettingProps) {
  const { hotspot } = useStore($editingHotspot)!;

  const showToggle = hotspot.icon.type !== HSIconType.mark;
  const showBtn = hotspot.icon.type === HSIconType.mark || !!hotspot.showTitle;

  useEffect(() => {
    return () => {
      $playerWidgetsApi.remove('title');
    };
  }, []);

  useEffect(() => {
    if (!showBtn) {
      $playerWidgetsApi.remove('title');
    }
  }, [showBtn]);

  const handlers = useTextareaHandelrs('trimRight', (val) => {
    $editingHotspotApi.update((draft) => {
      draft.title = val;
    });
  });

  const handleTitleToggle = (isOn: boolean) => {
    $editingHotspotApi.update((draft) => {
      draft.showTitle = toFlag(isOn);
    });
  };

  return (
    <Collapse title="标题设置">
      <Textarea
        scheme="dark"
        className="h-115"
        placeholder={placeholder}
        maxLength={500}
        value={hotspot.title}
        {...handlers}
      />
      {showToggle && (
        <FeatureToggle
          title="显示标题"
          className="mt-20"
          isOn={!!hotspot.showTitle}
          onToggle={handleTitleToggle}
        />
      )}
      {showBtn && (
        <Button
          className="mt-20 w-full"
          onClick={() => $playerWidgetsApi.add('title')}
        >
          标题高级设置
        </Button>
      )}
    </Collapse>
  );
}

export default TitleSetting;
